import React, { type FC, memo } from "react";
import { Card, Chip, Label, Radio } from "@heroui/react";
import { type GQL } from "@binale-tech/shared";

type Props = {
    connection: Partial<Pick<GQL.IFinApiBankConnection, "bank" | "accounts" | "id">>;
    getAccountValue: (account: GQL.IFinApiAccount) => string;
};

const FinApiBankConnectionCardImpl: FC<Props> = ({ connection, getAccountValue }) => {
    const { bank, accounts } = connection ?? {};

    return (
        <Card className="w-full">
            <Card.Header className="flex gap-3 items-center pb-2">
                {bank?.logo?.url && (
                    <img src={bank.logo.url} alt="bank logo" className="h-8 w-8 object-contain rounded" />
                )}
                <div className="flex flex-col">
                    <div className="flex items-center gap-2">
                        <span className="font-semibold">{bank?.name}</span>
                        {bank?.location && (
                            <Chip size="sm" variant="tertiary">
                                {bank.location}
                            </Chip>
                        )}
                    </div>
                    {bank?.city && <span className="text-sm text-muted">{bank.city}</span>}
                </div>
            </Card.Header>
            <Card.Content className="flex flex-col gap-2">
                {accounts?.map((account) => (
                    <Radio key={account.id} value={getAccountValue(account)}>
                        <Radio.Content>
                            <Radio.Control className="border">
                                <Radio.Indicator />
                            </Radio.Control>
                            <Label>
                                <div className="flex flex-col gap-0.5 ml-1">
                                    <div className="font-medium">
                                        {account.iban} · {account.accountType}
                                    </div>
                                    <div className="text-sm text-muted">{account.accountHolderName}</div>
                                    <div className="text-sm text-muted">{account.accountName}</div>
                                    <div className="text-sm">
                                        {account.balance} {account.accountCurrency}
                                    </div>
                                </div>
                            </Label>
                        </Radio.Content>
                    </Radio>
                ))}
            </Card.Content>
        </Card>
    );
};

export const FinApiBankConnectionCard = memo(FinApiBankConnectionCardImpl);
